import React from "react";
import clsx from "clsx";
import * as Icon from "react-feather";

import SkillTextService from "../../services/SkillTextService";
import BuildProgress from "./BuildProgress";

import "./build-conversation.css";

class BuildConversation extends React.Component {
	constructor(props) {
		super(props);
		this.messagesEndRef = React.createRef();
	}

	componentDidMount() {
		this.scrollToEnd();
	}

	componentDidUpdate(previousProps) {
		const isLonger = this.props.messages.length !== previousProps.messages.length || this.props.isSending !== previousProps.isSending;
		if (isLonger) this.scrollToEnd();
	}

	scrollToEnd() {
		if (this.messagesEndRef.current) this.messagesEndRef.current.scrollIntoView({ block: "end" });
	}

	onComposerKeyDown = event => {
		if (event.key === "Enter" && !event.shiftKey) {
			event.preventDefault();
			this.props.onSend();
		}
	};

	renderText({ text }) {
		const spans = SkillTextService.boldSpansOf({ text: String(text || "") });
		return spans.map((span, index) => (span.isBold ? <strong key={index}>{span.text}</strong> : <React.Fragment key={index}>{span.text}</React.Fragment>));
	}

	renderMessage = (message, index) => {
		const { messages, renderAttachment, hasWelcome } = this.props;
		const isPerson = message.from === "person";
		const isLatest = index === messages.length - 1;
		const isWelcome = hasWelcome && index === 0 && !isPerson;
		const attachment = renderAttachment ? renderAttachment({ message, isLatest }) : null;

		return (
			<div
				key={index}
				className={clsx(
					"build-conversation__message",
					isPerson ? "build-conversation__message--person" : "build-conversation__message--guide",
					message.kind && `build-conversation__message--${message.kind}`,
					isWelcome && "build-conversation__message--welcome"
				)}
			>
				{!isPerson && !isWelcome && (
					<span className="build-conversation__avatar">
						<Icon.Compass size={14} />
					</span>
				)}
				<div className="build-conversation__bubble-column">
					<div className="build-conversation__bubble">{this.renderText({ text: message.text })}</div>
					{attachment}
				</div>
			</div>
		);
	};

	render() {
		const { messages, isSending, progress, isOpen, draftText, onDraftTextChange, onSend, placeholder, secondaryAction, composerRef, hasWelcome } = this.props;
		const hasPersonMessage = messages.some(message => message.from === "person");
		const isFresh = hasWelcome && !isSending && !hasPersonMessage;

		return (
			<section className={clsx("build-conversation", "tk-card", isFresh && "build-conversation--fresh")}>
				<div className="build-conversation__messages">
					{messages.map(this.renderMessage)}
					{isSending && (
						<div className="build-conversation__message build-conversation__message--guide">
							<span className="build-conversation__avatar">
								<Icon.Compass size={14} />
							</span>
							<div className="build-conversation__bubble build-conversation__bubble--progress">
								{progress ? <BuildProgress {...progress} /> : "Working on it…"}
							</div>
						</div>
					)}
					<div ref={this.messagesEndRef} className="build-conversation__messages-end" />
				</div>
				{isOpen && (
					<div className="build-conversation__composer">
						<textarea
							ref={composerRef}
							className="build-conversation__input"
							rows={2}
							value={draftText}
							onChange={event => onDraftTextChange({ text: event.target.value })}
							onKeyDown={this.onComposerKeyDown}
							placeholder={placeholder || "Reply to the guide… (Enter to send, Shift+Enter for a new line)"}
							disabled={isSending}
						/>
						<div className="build-conversation__composer-actions">
							{secondaryAction}
							<button
								type="button"
								className="tk-button tk-button--primary tk-button--compact build-conversation__send"
								onClick={onSend}
								disabled={!draftText.trim() || isSending}
							>
								<Icon.Send size={13} />
								Send
							</button>
						</div>
					</div>
				)}
			</section>
		);
	}
}

BuildConversation.defaultProps = {
	hasWelcome: false,
};

export default BuildConversation;
